// src/api/clickTracking.js
import { api } from "./client";
import { API_BASE_URL } from "../utils/constants";

/**
 * Logs a product click/view into lender analytics.
 *
 * Confirmed endpoint:
 * POST /api/method/dynesourcerapi.views.log_mortgage_product_view
 *
 * NOTE:
 * If your backend expects different key names (e.g. `mortgage_product` instead of `product_id`)
 * then paste the exact Postman request body you send and I'll align it.
 */
export async function trackProductClick({
  product_id,
  product_name = "",
  source = "borrower_sourcing",
} = {}) {
  if (!product_id) {
    return { ok: false, skipped: true, reason: "missing product_id" };
  }

  const url = `${API_BASE_URL}/api/method/dynesourcerapi.views.log_mortgage_product_view`;

  const payload = {
    product_id,
    // Frappe endpoint expects Mortgage Product docname in `product_name`.
    product_name: product_name || product_id,
    source,
  };

  const res = await api.post(url, payload);

  return { ok: true, data: res?.data };
}

/**
 * Logs an Invoice Finance product click/view into lender analytics.
 * POST /api/method/dynesourcerapi.views.log_invoice_finance_view  body: { product_name }
 */
export async function trackInvoiceFinanceClick({ product_name } = {}) {
  if (!product_name) {
    return { ok: false, skipped: true, reason: "missing product_name" };
  }

  const url = `${API_BASE_URL}/api/method/dynesourcerapi.views.log_invoice_finance_view`;
  const res = await api.post(url, { product_name });

  return { ok: true, data: res?.data };
}
